var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50.96 44.32" }
    },
    [
      _c("g", [
        _c("g", [
          _c("path", {
            staticClass: "cls-1",
            attrs: {
              d:
                "M16.88,42.76l7.36-7.36a5.65,5.65,0,0,1,4-1.67H39.34a2.84,2.84,0,0,0,2-.83L49.29,25a5.68,5.68,0,0,0,1.67-4V15.12a1.14,1.14,0,0,0-2-.81l-7.39,7.18a6.75,6.75,0,0,1-9.48-.06l-2.8-2.8A6.76,6.76,0,0,1,29.4,9l7.27-7.07A1.14,1.14,0,0,0,35.86,0H30a5.71,5.71,0,0,0-4,1.66l-7.94,8a2.84,2.84,0,0,0-.83,2V22.71a5.69,5.69,0,0,1-1.66,4L6.64,35.65.42,41.88a1.43,1.43,0,0,0,1,2.44H13.1A5.34,5.34,0,0,0,16.88,42.76Z",
              fill: "currentColor"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }